<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ScheduleSlot',
  props: {
    slotByTime: { type: Object, required: true },
  },
  data() {
    return {
      groupedDoctors: undefined,
      isVariantsOpen: false,
    };
  },
  computed: {
    variantsAsArray() {
      const variantsArray = [];

      this.slotByTime?.variants.map((data) => {

        const subArr = [];
        Object.entries(data).map(([therapyUUID, value]) => {
          // Include therapyUUID in the value for duration lookup later
          subArr.push(Object.assign({}, value, { therapyUUID }));
        });

        variantsArray.push([
            ...subArr,
        ]);
      });

      return variantsArray;
    },
    docsGropedByTimeAvailable() {
      const docsGroupByTime = [];

      if (this.variantsAsArray.length === 1) {
        const docs = [];
        const groupByVariant = [];

        this.variantsAsArray[0].map((version) => {
          const sameTimeIndex = groupByVariant.findIndex(({ time }) => time === version[0]);
          const docsWithOverlap = [];
          const therapyUUID = version.therapyUUID;

          version[1].map((docInVersion) => {
            docsWithOverlap.push({
              ...docInVersion,
              isOverlap: !!version[3].includes(docInVersion.externalId),
              therapyUUID, // Add therapyUUID to each doctor
            });
          });

          if (sameTimeIndex < 0) {
            groupByVariant.push({
              time: version[0],
              doctors: docsWithOverlap,
              timestamp: version[2],
            });

          } else {
            groupByVariant[sameTimeIndex].doctors.push(...version[1]);
          }
        });

        docsGroupByTime.push(groupByVariant);
      } else if (this.variantsAsArray.length > 1) {
        this.variantsAsArray.map((variant) => {
          const groupByVariant = [];
          variant.map((version) => {
            const sameTimeIndex = groupByVariant.findIndex(({ time }) => time === version[0]);
            const docsWithOverlap = [];
            const therapyUUID = version.therapyUUID;

            version[1].map((docInVersion) => {
              docsWithOverlap.push({
                ...docInVersion,
                isOverlap: !!version[3].includes(docInVersion.externalId),
                therapyUUID, // Add therapyUUID to each doctor
              });
            });

            if (sameTimeIndex < 0) {
              groupByVariant.push({
                time: version[0],
                doctors: docsWithOverlap,
                timestamp: version[2],
              });

            } else {
              const docsWithOverlap = [];
              const therapyUUID = version.therapyUUID;

              version[1].map((docInVersion) => {
                docsWithOverlap.push({
                  ...docInVersion,
                  isOverlap: !!version[3].includes(docInVersion.externalId),
                  therapyUUID, // Add therapyUUID to each doctor
                });
              });

              groupByVariant[sameTimeIndex].doctors.push(...docsWithOverlap);
            }

          });

          docsGroupByTime.push(groupByVariant);
        });

      }

      return docsGroupByTime;
    },
    combainedDoctorVariants() {
      if (this.docsGropedByTimeAvailable.length > 0) {
        const returnArr = [];
        this.docsGropedByTimeAvailable.map((variantedGroup) => {
          const combinatedArr = this.doctorsCombinations(Object.assign([], variantedGroup));
          returnArr.push(...combinatedArr);
        });
        return returnArr;
      } else {
        return [];
      }
    },
    iconRotationStyle() {
      return this.isVariantsOpen ? { transform: 'rotate(-180deg)' } : { transform: 'rotate(-150deg)' };
    },
  },
  methods: {
    toggleCards() {
      this.isVariantsOpen = !this.isVariantsOpen;
    },
    selectSlot(variant: any) {

      this.$store.commit('setSelectedSlot', {
        datetime: this.slotByTime.datetime,
        time: variant.time,
        doctors: variant.doctors,
        variant,
      });

      // Emit event to parent that slot was selected
      this.$emit('slot-selected');
    },
    doctorsCombinations(arr) {
      if (arr.length === 0) {
        return [];
      }

      if (arr.length === 1) {
        return arr[0].doctors.map((doc) => ({ time: arr[0].time, doctors: [doc] }));
      }

      const combinations = [];
      const restCombinations = this.doctorsCombinations(Object.assign([], arr.slice(1))); // Recursive call without the first element
      for (const doc of arr[0].doctors) {
        for (const restCombination of restCombinations) {
          combinations.push({ time: arr[0].time, doctors: [doc, ...restCombination.doctors] });
        }
      }
      return combinations;
    },
  },
});
</script>

<template>
  <div class="wrapper">
    <div class="flex justify-start">
      <div class="mr-3 my-1" style="width: 10px">
        <v-icon v-if="combainedDoctorVariants.length > 1" class="triangle block" :style="iconRotationStyle" color="black" :size="10" @click="toggleCards">mdi-triangle</v-icon>
      </div>

      <div class="flex justify-between slotTimeCard" @click="selectSlot(combainedDoctorVariants[0])">
        <div class="ml-2 mr-6 time text-center">
          {{combainedDoctorVariants[0].time }}
        </div>
        <div class="flex justify-end flex-wrap" >
          <div class="doctorCell" v-for="doc in combainedDoctorVariants[0].doctors" :style="{ backgroundColor: `${doc.color}`}">
            {{ doc.name }}

            <v-icon
                v-if="doc.isOverlap"
                title="Overlapped"
                color="white"
                :size="17">
              mdi-information
            </v-icon>
          </div>
        </div>
      </div>

    </div>

    <div
        class="secondarySlotsWrapper"
        v-if="combainedDoctorVariants.length > 1 && isVariantsOpen"
    >
      <div class="flex justify-between my-1 slotTimeCard" v-for="variant in combainedDoctorVariants" @click="selectSlot(variant)">
        <div class="ml-2 mr-6 time text-center">{{variant.time}}</div>
        <div class="flex justify-end flex-wrap" >
          <div class="doctorCell"
               v-for="doc in variant.doctors"
               :style="{ backgroundColor: `${doc.color}`}">
            {{ doc.name }}

            <v-icon
                v-if="doc.isOverlap"
                title="Overlapped"
                color="white"
                :size="17">
              mdi-information
            </v-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.wrapper {
  min-width: 500px;
  width: 100%;
  margin: 15px 0;
  max-width: 70vw;
}
.time {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  min-width: 90px;
}
.slotTimeCard {
  background: #ffffff;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
}
.slotTimeCard:hover {
  background: #e1f1fa;
}
.doctorCell {
  border-radius: 4px;
  padding: 3px 10px;
  color: #ffffff;
  font-size: 14px;
  margin: 2px;
}

.secondarySlotsWrapper {
  border-left: 1px solid #D2D2D2;
  margin-left: 23px;
  padding-left: 15px
}
.triangle {
  transition: all 0.2s ease-in;
}
</style>
